import { useEffect, useMemo, useState } from "react";

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

const useTimer = ({ startDate = new Date().toUTCString(), endDate, delay = 1000, showDays = false }) => {
	if (!endDate) return { active: false };

	const parsedDeadline = useMemo(() => Date.parse(endDate), [endDate]);
	const parsedStartDate = useMemo(() => Date.parse(startDate), [startDate]);

	const calculateTimeDiff = () => {
		const now = Date.now();
		// If the start date is in the future, the timer is not active
		if (parsedStartDate > now) return { timer: parsedDeadline - parsedStartDate, active: false };
		const diff = parsedDeadline - now;
		return { timer: diff, active: diff > 0 };
	};

	const initialData = calculateTimeDiff();
	const [timerData, setTimerData] = useState(initialData);

	useEffect(() => {
		if (!timerData.active) return;

		const intervalTimer = setInterval(() => {
			const { timer, active } = calculateTimeDiff();

			if (!active)
				clearInterval(intervalTimer);

			setTimerData({ timer, active });
		}, delay);

		return () => clearInterval(intervalTimer);
	}, [parsedDeadline, parsedStartDate]);

	const mapTimerObject = (timer) => {
		const days = Math.floor(timer / DAY);
		const hours = Math.floor((timer / HOUR) % 24);
		const minutes = Math.floor((timer / MINUTE) % 60);
		const seconds = Math.floor((timer / SECOND) % 60);

		return showDays ? { days, hours, minutes, seconds } : { hours: days * 24 + hours, minutes, seconds };
	};

	const timer = mapTimerObject(timerData.timer);

	return {
		active: timerData.active,
		timer,
	};
};

export default useTimer;